import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

/**
 * Who a NEW invoice for this project, client and DBA would go to, and where they came from
 * (SPEC-christa-contacts-identity R1 AC14/AC15). The server answers with the same code `create_invoice` uses,
 * so the Create Invoice form shows what the saved invoice will actually get. Asks again whenever the project,
 * client scope, client or DBA changes (they are all part of the query key).
 *
 * `establishmentId` is the DBA the form will SEND: leave it undefined for an untouched picker so the server
 * decides, exactly as it does on create.
 */
export function useInvoiceRecipientPreview(params: {
  projectId: string | undefined;
  organizationId: string | undefined;
  clientScopeId?: string | null;
  establishmentId?: number | null;
}) {
  const { projectId, organizationId, clientScopeId, establishmentId } = params;
  return useQuery({
    queryKey: [
      'invoice-recipient-preview', projectId, organizationId, clientScopeId ?? null, establishmentId ?? null,
    ] as const,
    queryFn: () =>
      api.projects.getInvoiceRecipientPreview(projectId!, {
        organization_id: organizationId!,
        ...(clientScopeId ? { client_scope_id: clientScopeId } : {}),
        ...(establishmentId !== undefined && establishmentId !== null ? { establishment_id: establishmentId } : {}),
      }),
    enabled: !!projectId && !!organizationId,
    // A preview must never be reused after the people behind it changed on another screen.
    staleTime: 0,
  });
}
